module.exports = __webpack_public_path__ + "img/logo.34faed6d.svg";